var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"learnworlds-main-text learnworlds-main-text-small learnworlds-element",on:{"click":_vm.seeAllClicked}},[_c('a',[_vm._v(_vm._s(_vm.$t('blog.see_all')))])])}
var staticRenderFns = []

export { render, staticRenderFns }